<template>
  <div id="financial-home">  
    <v-card flat>
      <v-img
        :src="titleImg"
        max-height="200"
        aspect-ratio=1.5
        position="center left"
        gradient="to right, rgba(0,0,0,.44), rgba(0,0,0,.44)"
      />
    </v-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      titleImg: 'https://images.unsplash.com/photo-1508420972834-c0781cbb4fd8?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=bae92a152560ef705f76f4ec026e9df6&auto=format&fit=crop&w=1350&q=80'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/financial/Financial.vue